import { defineMessages } from "react-intl";

import {
	hbcAbIggMessages,
	hbcAbIgmMessages,
	hbsAbMessages,
	hbsAgMessages,
	validator
} from "lib/build/forms/htx/microbiological-procedures/hbvStatus";

import { FieldData, FieldsetData } from "src/features/forms";
import { genericErrorMessages } from "src/messages/generic";
import { LeafNode } from "src/modules/shared/form-explorer";

const messages = defineMessages({
	hbvStatus: {
		id: "form.hbv_status",
		defaultMessage: "HBV státusz"
	},
	hbcAbIgg: {
		id: "form.hbv_status.hbc_ab_igg",
		defaultMessage: "HBc-Ab IgG"
	},
	hbsAb: {
		id: "form.hbv_status.hbs_ab",
		defaultMessage: "HBs-Ab"
	},
	hbsAg: {
		id: "form.hbv_status.hbs_ag",
		defaultMessage: "HBs-Ag"
	},
	hbcAbIgm: {
		id: "form.hbv_status.hbc_ab_igm",
		defaultMessage: "HBc-Ab IgM"
	}
});

const fields: { [key: string]: FieldData } = {
	hbcAbIgg: {
		type: "field",
		path: ["hbcAbIgg"],
		label: messages.hbcAbIgg,
		errorMessages: genericErrorMessages,
		input: { type: "button-group", props: { labels: hbcAbIggMessages } }
	},
	hbsAb: {
		type: "field",
		path: ["hbsAb"],
		label: messages.hbsAb,
		errorMessages: genericErrorMessages,
		input: { type: "button-group", props: { labels: hbsAbMessages } }
	},
	hbsAg: {
		type: "field",
		path: ["hbsAg"],
		label: messages.hbsAg,
		errorMessages: genericErrorMessages,
		input: { type: "button-group", props: { labels: hbsAgMessages } }
	},
	hbcAbIgm: {
		type: "field",
		path: ["hbcAbIgm"],
		label: messages.hbcAbIgm,
		errorMessages: genericErrorMessages,
		input: { type: "button-group", props: { labels: hbcAbIgmMessages } }
	}
};

const fieldset: FieldsetData = {
	rows: [
		{ columns: [{ width: 12, field: fields.hbcAbIgg }] },
		{ columns: [{ width: 12, field: fields.hbsAb }] },
		{ columns: [{ width: 12, field: fields.hbsAg }] },
		{ columns: [{ width: 12, field: fields.hbcAbIgm }] }
	]
};

export const node: LeafNode = {
	id: "hbvStatus",
	value: {
		title: messages.hbvStatus,
		validator,
		fieldset,
		isImportant: true
	}
};
